import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import { NavigationItem } from '../../../../../../../../aumico-components/src/lib/components/tab-navigation/tab-navigation.component';

@UntilDestroy()
@Component({
    selector: 'app-fcp-card',
    templateUrl: 'fcpCard.component.html',
    styleUrls: ['fcpCard.component.scss'],
})
export class FcpCardComponent {
    @Input() title: string;
    @Input() hasOtherYear: boolean = false;
    @Input() isEditable: boolean = false;
    @Input() icon: string | null = null;
    @Input() expanded: boolean = true;
    @Input() hasAddButton: boolean = false;
    @Input() addButtonText: string = '';
    @Output() expandedChange = new EventEmitter<boolean>();

    isMainContentActive: boolean = true;

    navigationItems: NavigationItem[] = [];
    public tabsTitles: string[] = [];
    @Output() onEdit = new EventEmitter<void>();
    @Output() onAdd = new EventEmitter<void>();

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private i18next: I18NextService,
    ) {
        this.addSvgIcon('aumico-pattern-icon-notes-edit-black');

        this.navigationItems = [
            { name: this.i18next.t('aumico_reports_this_year') as string, active: true },
            { name: this.i18next.t('aumico_reports_last_year') as string, active: false },
        ];

        this.tabsTitles = this.navigationItems.map((item) => item.name);
    }

    get iconStyle() {
        return this.icon ? { '-webkit-mask-image': `url(${this.icon})`, 'mask-image': `url(${this.icon})` } : {};
    }

    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    toggleContent() {
        this.isMainContentActive = !this.isMainContentActive;
    }

    toggleAccordion() {
        this.expanded = !this.expanded;
        this.expandedChange.emit(this.expanded); // Emit the new state
    }

    switchYear(item: NavigationItem) {
        if (item.name === (this.i18next.t('aumico_reports_this_year') as string)) {
            this.isMainContentActive = true;
            this.navigationItems[0].active = true;
            this.navigationItems[1].active = false;
        } else {
            this.isMainContentActive = false;
            this.navigationItems[0].active = false;
            this.navigationItems[1].active = true;
        }
    }

    onEditClick() {
        this.onEdit.emit();
    }

    onAddClick() {
        console.log('onAddClick');
        this.onAdd.emit();
    }
}
